<template>
  <div class="welfareHouse">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="机构介绍" name="1"></el-tab-pane>
      <el-tab-pane label="历史介绍" name="2"></el-tab-pane>
      <el-tab-pane label="优秀员工介绍" name="3"></el-tab-pane>
      <el-tab-pane label="入院流程介绍" name="4"></el-tab-pane>
    </el-tabs>
    <div class="editor-container">
      <div ref="editorElem" style="height: 500px;"></div>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 30px">
      <el-button
        :size="size"
        type="primary"
        plain
        @click.native="submitForm"
        :loading="sureLoading"
        >保存</el-button
      >
    </div>
  </div>
</template>
<script>
import wangEditor from 'wangeditor'
export default {
  name: "WelfareHouse",
  data() {
    return {
      isPic: false, //判断是图片还是视频
      vidioSrc: {}, //视频显示
      fileList: [], //图片回显
      firstPic: "",
      editor:null,
      firstPicList: [],
      content:"",
      postPic: "",
      activeName: "1",
      groupId: "", //机构id
      size: "medium", //按钮的尺寸
      sureLoading: false, //按钮加载
      remarkLength: "", //富文本字符长度
      defaultMsg: "",
      dataForm: {
        remark: "",
      },
    };
  },
  methods: {
    //翻页
    handleClick() {
      this.firstPicList = [];
      if (this.activeName == "5") {
        this.isAddVideo = false;
      } else {
        this.isAddVideo = true;
      }
      this.backList();
    },
    //富文本编辑框回显数据
    setUEContent(val) {
      this.content = val;
      this.editor.txt.html(val)
    },
    // 点击提交数据
    submitForm() {
      this.upResource();
    },

    //上传资源
    upResource() {
      let remark =  this.content
            .replace(/<[^<>]+>/g, "")
            .replace(/&nbsp;/gi, "");
      let params = {
        introduce: this.content,
        remark: remark,
        introduceType: Number(this.activeName)
      };
      this.$postJson("omc/queryMachine/saveIntroduce", params).then((res) => {
        if (res.code == 200) {
          this.$message({ message: res.message, type: "success" });
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },

    //回显数据
    backList() {
      this.fileList = []; //清空数据
      let type = Number(this.activeName);
      this.$postJson(
        "omc/queryMachine/getIntroduceByIntroduceType/" + type
      ).then((res) => {
        if (res.result.length > 0) {
          this.setUEContent(res.result[0].introduce); //加载完成调取函数回显富文本框的数据
        } else {
          this.setUEContent("");
        }
      });
    },
  },
  created() {
    this.groupId = sessionStorage.getItem("groupId");
  },
  destroyed() {
    // 销毁编辑器
    this.editor.destroy();
 },
  mounted() {
    // 初始化编辑器
    this.editor = new wangEditor(this.$refs.editorElem);
    // 配置编辑器
    this.editor.config.uploadImgShowBase64 = false; // 显示Base64编码的图片
    this.editor.config.uploadImgMaxLength = 3 * 1024 * 1024; // 限制上传图片的大小为5MB
    this.editor.config.emotions = null;
    this.editor.config.onchange = html => {
      this.content = html;
    };
    // 创建编辑器
    this.editor.create();
    this.handleClick();
  },
};
</script>
<style lang="scss" scoped>
.welfareHouse {
  width: 100%;
  height: 100%;
  background: #fff;
  .editor-container {
    width: 100%;
    height: 600px;
  }
}

::v-deep .w-e-text-container{
  height: 95% !important;
}
</style>